<template>
  <Wrapper>
    <div class="container-fluid pb-0">
      <VideoPlyrPlaylist />
    </div>
  </Wrapper>
</template>

<script>
export default {
  components: {
    VideoPlyrPlaylist: () => import('@/components/video/VideoPlyrPlaylist'),
  },
};
</script>
